import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import EquiptmentView from 'src/views/equipment';
import CatalogView from 'src/views/catalog';
import { selectUserRedirectBySystemRol } from 'src/utils/common';
import { selectAuthSystem } from 'src/store/selectors/authSelectors';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import SuperAdminPrivateRoute from 'src/components/PrivateRotes/SuperAdminPrivateRoute';
import { useSelector } from 'react-redux';
import ParameterView from './parameter';
import ClientsView from './client';
import InsurancesView from './insurance';
import ContractView from './contract';
import TransactionView from './transaction';
import FiscalInterestBalanceView from './balances/interestBalance/FiscalInterestBalanceView';
import BillingView from './billing';
import FiscalCapitalBalanceView from './balances/capitalBalance/FiscalCapitalBalanceView';
import FiscalCapitalBalanceSummaryView from './balances/capitalBalance/FiscalCapitalBalanceSummaryView';
import AccountingInterestBalanceView from './balances/interestBalance/AccountingInterestBalanceView';
import AccountingCapitalBalanceView from './balances/capitalBalance/AccountingCapitalBalanceView';
import AccountingCapitalBalanceSummaryView from './balances/capitalBalance/AccountingCapitalBalanceSummaryView';
import FiscalTerminationAuditView from './balances/capitalBalance/FiscalTerminationAuditView';
import AccountingTerminationAuditView from './balances/capitalBalance/AccountingTerminationAuditView';
import ContractActionsView from './balances/actions/ContractActionsView';
import IncomeView from './income';
import BusinessView from './business';
import PolicyView from './policy';
import QuotersView from './quoter';
import QuotesView from './quotes';
import AdministratorsView from './administrator';
import InverstorsView from './investor';
import CounselorsView from './counselor';
import TaxAccountingView from './taxAccounting';
import AvalDetailView from './client/AvalDetail';
import TransactionDetailView from './client/TransactionDetail';
import IdentityView from './backgroundValidation';
import UpfrontRentsListView from './upfrontRents';
import FailuresView from './failures';
import SantanderClabesListView from './administrator/santanderClabes/SantanderClabesListView';
import SantanderReportsView from './santanderReports';
import CardMovementsView from './card-movements';
import KamDetailView from './kam';

const DashboardViews = () => {
  const systemRol = useSelector(selectAuthSystem);
  return (
    <DashboardLayout>
      <Routes>
        <Route path="inventory/*" element={<RolePrivateRoute component={EquiptmentView} />} />
        <Route path="catalogs/*" element={<RolePrivateRoute component={CatalogView} />} />
        <Route path="parameters/*" element={<RolePrivateRoute component={ParameterView} />} />
        <Route path="clients/*" element={<RolePrivateRoute component={ClientsView} />} />
        <Route path="aval/detail/:avalId/*" element={<RolePrivateRoute component={AvalDetailView} />} />
        <Route path="aval/detail/:avalId" element={<RolePrivateRoute component={AvalDetailView} />} />
        <Route path="invoice/:invoiceId" element={<RolePrivateRoute component={TransactionDetailView} />} />
        <Route path="contracts/*" element={<RolePrivateRoute component={ContractView} />} />
        <Route path="insurances/*" element={<RolePrivateRoute component={InsurancesView} />} />
        <Route path="transactions/*" element={<RolePrivateRoute component={TransactionView} />} />
        <Route path="card-movements/*" element={<RolePrivateRoute component={CardMovementsView} />} />
        <Route path="billing/*" element={<RolePrivateRoute component={BillingView} />} />
        <Route path="investors/*" element={<RolePrivateRoute component={InverstorsView} />} />
        <Route path="counselors/*" element={<RolePrivateRoute component={CounselorsView} />} />
        <Route path="fiscal-balance/interest/*" element={<RolePrivateRoute component={FiscalInterestBalanceView} />} />
        <Route path="fiscal-balance/capital/*" element={<RolePrivateRoute component={FiscalCapitalBalanceView} />} />
        <Route path="balances/fiscal-capital-balance/summary/*" element={<RolePrivateRoute component={FiscalCapitalBalanceSummaryView} />} />
        <Route path="accounting-balance/interest/*" element={<RolePrivateRoute component={AccountingInterestBalanceView} />} />
        <Route path="accounting-balance/capital/*" element={<RolePrivateRoute component={AccountingCapitalBalanceView} />} />
        <Route
          path="fiscal-balance/termination-audit/*"
          element={<RolePrivateRoute component={FiscalTerminationAuditView} />}
        />
        <Route
          path="accounting-balance/termination-audit/*"
          element={
            <RolePrivateRoute component={AccountingTerminationAuditView} />
          }
        />
        <Route path="balances/accounting-capital-balance/summary/*" element={<RolePrivateRoute component={AccountingCapitalBalanceSummaryView} />} />
        <Route path="actions/*" element={<RolePrivateRoute component={ContractActionsView} />} />
        <Route path="income/*" element={<RolePrivateRoute component={IncomeView} />} />
        <Route path="policies/*" element={<RolePrivateRoute component={PolicyView} />} />
        <Route path="distributor-profile/:id" element={<RolePrivateRoute component={KamDetailView} />} />
        <Route path="distributors/*" element={<RolePrivateRoute component={BusinessView} />} />
        <Route path="quoters/*" element={<RolePrivateRoute component={QuotersView} />} />
        <Route path="tax-accounting/*" element={<RolePrivateRoute component={TaxAccountingView} />} />
        <Route path="identity/*" element={<RolePrivateRoute component={IdentityView} />} />
        <Route path="failures/*" element={<RolePrivateRoute component={FailuresView} />} />
        <Route path="upfront-rents/*" element={<RolePrivateRoute component={UpfrontRentsListView} />} />
        <Route path="santander-clabes/*" element={<RolePrivateRoute component={SantanderClabesListView} />} />
        <Route path="santander-reports/*" element={<RolePrivateRoute component={SantanderReportsView} />} />
        <Route path="quotes/*" element={<RolePrivateRoute component={QuotesView} />} />
        <Route path="super-admin/*" element={<SuperAdminPrivateRoute component={AdministratorsView} />} />
        <Route index element={<Navigate to={selectUserRedirectBySystemRol(systemRol)} replace />} />
      </Routes>
    </DashboardLayout>
  );
};

export default DashboardViews;
